import {
  Box,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  Table,
  TableRow,
  Paper,
  Typography,
  Fab,
} from "@mui/material";
import { useEffect, useState } from "react";
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination";
import SearchBar from "../component/SearchBar";
import { Link } from "react-router-dom";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { useHistory } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import usePostData from "../../../utility/usePostData";

const filterData = (query, data) => {
  if (!query) {
    return data;
  } else {
    return data.filter((d) => JSON.stringify(d).toLowerCase().includes(query));
  }
};

const InstitionList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const {
    data: institutions,
    isLoading,
    error,
    paginate,
    searchIntoDatabase,
    refreshSearch,
    changePage,
    currentPage,
    perPage,
  } = useFetchDataWithPagination("institutions");
  const info = filterData(searchQuery, institutions?.data?.data);
  const startingIndex =
    ((institutions?.data?.current_page ?? currentPage) - 1) *
    (institutions?.data?.per_page ?? perPage);
  const history = useHistory();
  const { submitData } = usePostData();

  const addUserToInstution = (instutionId) => {
    // console.log(instutionId)
    history.push("add-user-to-institution/" + instutionId);
  };
  const updateSearch = (e) => {
    e.preventDefault();
    if (searchQuery === "") {
      //Recuperer tout les données
      searchIntoDatabase("institutions/search/ALL_DATA");
    } else {
      searchIntoDatabase("institutions/search/" + searchQuery);
    }
  };
  const deleteInstitution = async (institution) => {
    const response = window.confirm(
      "Confirmez la suppression de : " + institution.name,
    );
    if (!response) return;

    const res = await submitData(
      "institutions/" + institution.id,
      null,
      "DELETE",
    );
    if (!res) {
      // deletion failed — leave current view and optionally show an error
      // You can add a toast here if desired
      return;
    }

    // Refresh the current page
    const refreshed = await refreshSearch();

    // Determine if the current page is now empty — if so and we're not on page 1, go to previous page
    const refreshedDataArray = refreshed?.data?.data?.data ?? [];
    const total = refreshed?.data?.data?.total ?? 0;
    const per_page = refreshed?.data?.data?.per_page ?? perPage;
    const pageCount = Math.max(1, Math.ceil(total / per_page));

    if (refreshedDataArray.length === 0 && currentPage > 1) {
      await changePage(currentPage - 1);
    }
  };

  useEffect(() => {
    return () => {};
  }, [paginate, isLoading, error]);

  return (
    <Box sx={{ m: 1, width: "95%", margin: "auto", mt: 3 }}>
      <Paper elevation={2} sx={{ p: 3 }}>
        <div className="mb-4">
          <Typography
            variant="h5"
            component="h4"
            sx={{ color: "#00a652", fontWeight: 500 }}
          >
            Liste des institutions
          </Typography>
          {isLoading && <div className="alert alert-info">Chargement...</div>}
          {error && <div className="alert alert-danger">{error.message}</div>}
        </div>

        <div className="row align-items-center mb-4">
          <div className="col-md-6"></div>
          <div className="col-md-4">
            <SearchBar
              setSearchQuery={setSearchQuery}
              handleSubmit={updateSearch}
            />
          </div>
          <div className="col-md-2">
            <Link
              to="/institutions/add"
              className="btn d-flex align-items-center"
              style={{ backgroundColor: "#00a652", color: "white" }}
            >
              <PersonAddAltIcon sx={{ mr: 1 }} /> Nouveau
            </Link>
          </div>
        </div>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow style={{ backgroundColor: "#00a652" }}>
                <TableCell style={{ color: "white", fontWeight: 500 }}>
                  #
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: 500 }}>
                  Name
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: 500 }}>
                  Type
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: 500 }}>
                  Addresse
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: 500 }}>
                  Code de l'institution
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: 500 }}>
                  Phone
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: 500 }}>
                  Email
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: 500 }}>
                  Date de création
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: 500 }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {info &&
                info.map((institution, index) => (
                  <TableRow key={institution.id} hover>
                    <TableCell>{startingIndex + index + 1}</TableCell>
                    <TableCell>{institution.name}</TableCell>
                    <TableCell>
                      <span
                        style={{
                          backgroundColor: "#00a652",
                          color: "white",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          fontSize: "0.85rem",
                        }}
                      >
                        {institution.typeInstution}
                      </span>
                    </TableCell>
                    <TableCell>{institution.address}</TableCell>
                    <TableCell>{institution.identify}</TableCell>
                    <TableCell>{institution.telephone}</TableCell>
                    <TableCell>{institution.email}</TableCell>
                    <TableCell>
                      {new Date(institution.created_at).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Fab
                          size="small"
                          sx={{
                            backgroundColor: "#00a652",
                            color: "white",
                            "&:hover": { backgroundColor: "#00a652" },
                          }}
                          onClick={() => addUserToInstution(institution.id)}
                        >
                          <PersonAddAltIcon />
                        </Fab>
                        <Fab
                          size="small"
                          sx={{
                            backgroundColor: "#00a652",
                            color: "white",
                            "&:hover": { backgroundColor: "#00a652" },
                          }}
                          onClick={() =>
                            history.push("institution_edit/" + institution.id)
                          }
                        >
                          <EditIcon />
                        </Fab>
                        <Fab
                          size="small"
                          sx={{
                            backgroundColor: "#ec1a20",
                            color: "white",
                            "&:hover": { backgroundColor: "#d41118" },
                          }}
                          onClick={() => deleteInstitution(institution)}
                        >
                          <DeleteIcon />
                        </Fab>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div className="mt-3">{paginate()}</div>
      </Paper>
    </Box>
  );
};

export default InstitionList;
